import * as React from "react";
import { RegionGenConfig } from "./regiongenconfig";
import { RegionGenerator } from "./regiongenerator";
export class RegionForm extends React.Component {
    regionGenerator;
    constructor(props) {
        super(props);
        this.state = new RegionGenConfig();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRegionPopulation = this.handleRegionPopulation.bind(this);
        this.handleRegionSizeMilesSq = this.handleRegionSizeMilesSq.bind(this);
        this.handleRegionAgeYears = this.handleRegionAgeYears.bind(this);
        this.handleLivestockPerPerson = this.handleLivestockPerPerson.bind(this);
        this.handlePeoplePerCastle = this.handlePeoplePerCastle.bind(this);
        this.handlePeoplePerRuinedCastle = this.handlePeoplePerRuinedCastle.bind(this);
        this.handlePercentageOfLivestockIsFowl = this.handlePercentageOfLivestockIsFowl.bind(this);
        this.handlePercentageOfCastlesInOutskirts = this.handlePercentageOfCastlesInOutskirts.bind(this);
        this.handlepeoplePerFarmlandSqMiles = this.handlepeoplePerFarmlandSqMiles.bind(this);
        this.handleAverageFarmSizeAcres = this.handleAverageFarmSizeAcres.bind(this);
        this.handleHouseholdSize = this.handleHouseholdSize.bind(this);
        this.handleWarehousesPerBuildingMultiplier = this.handleWarehousesPerBuildingMultiplier.bind(this);
        this.handlecityPeoplePerMileSq = this.handlecityPeoplePerMileSq.bind(this);
        this.regionGenerator = new RegionGenerator();
    }
    handleAverageFarmSizeAcres(event) {
        this.setState({ AverageFarmSizeAcres: Number.parseInt(event.target.value, 10) });
    }
    handlecityPeoplePerMileSq(event) {
        this.setState({ CityPeoplePerSqMile: Number.parseInt(event.target.value, 10) });
    }
    handleHouseholdSize(event) {
        this.setState({ HouseholdSize: Number.parseInt(event.target.value, 10) });
    }
    handleLivestockPerPerson(event) {
        this.setState({ LivestockPerPerson: Number.parseInt(event.target.value, 10) });
    }
    handlePeoplePerCastle(event) {
        this.setState({ PeoplePerCastle: Number.parseInt(event.target.value, 10) });
    }
    handlepeoplePerFarmlandSqMiles(event) {
        this.setState({ PeoplePerSqMileFarmland: Number.parseInt(event.target.value, 10) });
    }
    handlePeoplePerRuinedCastle(event) {
        this.setState({ PeoplePerRuinedCastle: Number.parseInt(event.target.value, 10) });
    }
    handlePercentageOfCastlesInOutskirts(event) {
        this.setState({ PercentageOfCastlesInOutskirts: Number.parseInt(event.target.value, 10) });
    }
    handlePercentageOfLivestockIsFowl(event) {
        this.setState({ PercentageOfLivestockIsFowl: Number.parseInt(event.target.value, 10) });
    }
    handleRegionAgeYears(event) {
        this.setState({ RegionAgeYears: Number.parseInt(event.target.value, 10) });
    }
    handleRegionPopulation(event) {
        this.setState({ RegionPopulation: Number.parseInt(event.target.value, 10) });
    }
    handleRegionSizeMilesSq(event) {
        this.setState({ RegionSizeSqMiles: Number.parseInt(event.target.value, 10) });
    }
    handleSubmit(event) {
        const region = this.regionGenerator.generate(this.state);
        this.props.onFormSubmit(region);
        event.preventDefault();
    }
    handleWarehousesPerBuildingMultiplier(event) {
        this.setState({ WarehousesPerBuildingMultiplier: Number.parseInt(event.target.value, 10) });
    }
    render() {
        const regionPop = this.state.RegionPopulation;
        const regionMilesSq = this.state.RegionSizeSqMiles;
        const regionAgeYears = this.state.RegionAgeYears;
        const livestockPerPerson = this.state.LivestockPerPerson;
        const peoplePerCastle = this.state.PeoplePerCastle;
        const peoplePerRuinedCastle = this.state.PeoplePerRuinedCastle;
        const percentageOfLivestockIsFowl = this.state.PercentageOfLivestockIsFowl;
        const percentageOfCastlesInOutskirts = this.state.PercentageOfCastlesInOutskirts;
        const peoplePerFarmlandSqMiles = this.state.PeoplePerSqMileFarmland;
        const averageFarmSizeAcres = this.state.AverageFarmSizeAcres;
        const householdSize = this.state.HouseholdSize;
        const warehousesPerBuildingMultiplier = this.state.WarehousesPerBuildingMultiplier;
        const cityPeoplePerMileSq = this.state.CityPeoplePerSqMile;
        return (React.createElement("div", null,
            React.createElement("form", { action: "javascript:void(0);", onSubmit: this.handleSubmit },
                React.createElement("fieldset", null,
                    React.createElement("legend", null, "Region Parameters"),
                    React.createElement("div", null,
                        React.createElement("label", { htmlFor: "regionPop" }, "Region Total Population"),
                        React.createElement("input", { id: "regionPop", type: "number", min: "0", value: regionPop, onChange: this.handleRegionPopulation }),
                        React.createElement("p", null, "Population affects the number of castles, villages, towns, and cities")),
                    React.createElement("div", null,
                        React.createElement("label", { htmlFor: "regionMilesSq" }, "Region Area Size Miles\u00B2"),
                        React.createElement("input", { id: "regionMilesSq", type: "number", min: "0", value: regionMilesSq, onChange: this.handleRegionSizeMilesSq }),
                        React.createElement("p", null, "Total size of the region, including inhospitable land"))),
                React.createElement("fieldset", null,
                    React.createElement("legend", null, "Castle Settings"),
                    React.createElement("div", null,
                        React.createElement("label", { htmlFor: "regionAgeYears" }, "Region Age Years"),
                        React.createElement("input", { id: "regionAgeYears", type: "number", min: "0", value: regionAgeYears, onChange: this.handleRegionAgeYears }),
                        React.createElement("p", null, "Older regions have more ruined / abandoned castles")),
                    React.createElement("div", null,
                        React.createElement("label", { htmlFor: "peoplePerCastle" }, "People per Castle"),
                        React.createElement("input", { type: "number", id: "peoplePerCastle", min: "0", value: peoplePerCastle, onChange: this.handlePeoplePerCastle })),
                    React.createElement("div", null,
                        React.createElement("label", { htmlFor: "peoplePerRuinedCastle" }, "People per Ruined Castle"),
                        React.createElement("input", { type: "number", id: "peoplePerRuinedCastle", min: "0", value: peoplePerRuinedCastle, onChange: this.handlePeoplePerRuinedCastle })),
                    React.createElement("div", null,
                        React.createElement("label", { htmlFor: "percentageOfCastlesInOutskirts" }, "Castle % in outskirts"),
                        React.createElement("input", { type: "number", id: "percentageOfCastlesInOutskirts", min: "0", step: "0.01", value: percentageOfCastlesInOutskirts, onChange: this.handlePercentageOfCastlesInOutskirts }))),
                React.createElement("fieldset", null,
                    React.createElement("legend", null, "City Settings"),
                    React.createElement("div", null,
                        React.createElement("label", { htmlFor: "warehousesPerBuildingMultiplier" }, "Warehouses per Building Multiplier"),
                        React.createElement("input", { type: "number", id: "warehousesPerBuildingMultiplier", min: "0", step: "0.1", value: warehousesPerBuildingMultiplier, onChange: this.handleWarehousesPerBuildingMultiplier }),
                        React.createElement("p", null, "Used in conjunction with people per household to determine storage requirements of the cities.")),
                    React.createElement("div", null,
                        React.createElement("label", { htmlFor: "cityPeoplePerMileSq" }, "City People per Miles\u00B2"),
                        React.createElement("input", { type: "number", id: "cityPeoplePerMileSq", min: "0", value: cityPeoplePerMileSq, onChange: this.handlecityPeoplePerMileSq }),
                        React.createElement("p", null, "Average density is ~40,000 per Mile\u00B2. Lowering this will create larger (in area) cities"))),
                React.createElement("fieldset", null,
                    React.createElement("legend", null, "Farming Settings"),
                    React.createElement("div", null,
                        React.createElement("label", { htmlFor: "peoplePerFarmlandSqMiles" }, "People Per Mile\u00B2 Farmland"),
                        React.createElement("input", { type: "number", id: "peoplePerFarmlandSqMiles", min: "0", value: peoplePerFarmlandSqMiles, onChange: this.handlepeoplePerFarmlandSqMiles }),
                        React.createElement("p", null, "The viability of the farmable land itself, assuming maximum productivity. Higher numbers reduce sprawl, increase density")),
                    React.createElement("div", null,
                        React.createElement("label", { htmlFor: "averageFarmSizeAcres" }, "Average Farm Size Acres"),
                        React.createElement("input", { type: "number", id: "averageFarmSizeAcres", min: "0", value: averageFarmSizeAcres, onChange: this.handleAverageFarmSizeAcres }),
                        React.createElement("p", null, "The productivity of a single farmer, and the amount of land they can work. Higher numbers reduce sprawl, increase density. The average farm size is normally between 20 to 40 acres.")),
                    React.createElement("div", null,
                        React.createElement("label", { htmlFor: "householdSize" }, "Household Size"),
                        React.createElement("input", { type: "number", id: "householdSize", min: "0", value: householdSize, onChange: this.handleHouseholdSize }),
                        React.createElement("p", null, "Average people per household. Higher numbers significantly increase sprawl, reduce density")),
                    React.createElement("div", null,
                        React.createElement("label", { htmlFor: "livestockPerPerson" }, "Livestock per Person"),
                        React.createElement("input", { type: "number", id: "livestockPerPerson", min: "0", step: "0.1", value: livestockPerPerson, onChange: this.handleLivestockPerPerson }),
                        React.createElement("p", null, "Medieval societies had a lot of animals, mostly work animals. This includes Cows, Sheeps, Pigs, Chickens, etc.")),
                    React.createElement("div", null,
                        React.createElement("label", { htmlFor: "percentageOfLivestockIsFowl" }, "Livestock Fowl Ratio"),
                        React.createElement("input", { type: "number", id: "percentageOfLivestockIsFowl", min: "0", step: "0.01", value: percentageOfLivestockIsFowl, onChange: this.handlePercentageOfLivestockIsFowl }),
                        React.createElement("p", null, "Medieval societies generally raised more fowl. Higher percentages imply more fowl. (Chickens, Turkeys, etc.)"))),
                React.createElement("button", { className: "laff-btn laff-btn-primary", type: "submit" }, "Generate Region"))));
    }
}
//# sourceMappingURL=regionform.js.map